import React from 'react';
import { TableBody, TableHead } from '@mui/material';
import { StyledTable } from './BlockTableStyles';

const BlockTable = ({ children }) => {
  const [header, ...rows] = React.Children.toArray(children);
  const columnCount = React.Children.count(header.props.children);
  console.log(`Number of columns: ${columnCount}`);

  return (
    <StyledTable $columnCount={columnCount}>
      <TableHead>{header}</TableHead>
      <TableBody>{rows}</TableBody>
    </StyledTable>
  );
};

export default BlockTable;
